var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpposed = function SvgOpposed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#FF7017",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.22275 13.0994H6.57275C6.12402 13.0994 5.76025 12.7357 5.76025 12.2869V6.70993C5.76025 6.26119 6.12402 5.89743 6.57275 5.89743H7.22275C7.67149 5.89743 8.03525 6.26119 8.03525 6.70993V12.2869C8.03525 12.7357 7.67149 13.0994 7.22275 13.0994Z",
    stroke: "#FF7017",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.03516 11.8401V7.52298C8.03516 7.092 8.20636 6.67868 8.51111 6.37393C8.81585 6.06918 9.22918 5.89798 9.66016 5.89798H13.383C13.6801 5.89796 13.9689 5.99563 14.205 6.17592C14.4411 6.35622 14.6113 6.60914 14.6895 6.89573L15.7501 10.7892C15.8048 10.9901 15.8125 11.2009 15.7725 11.4052C15.7325 11.6095 15.646 11.8018 15.5196 11.9672C15.3932 12.1326 15.2304 12.2667 15.0438 12.359C14.8572 12.4513 14.6518 12.4993 14.4436 12.4993H12.2255V14.5625C12.2255 14.8498 12.1114 15.1253 11.9082 15.3285C11.705 15.5317 11.4295 15.6458 11.1422 15.6458H11.1227C10.9433 15.6458 10.7668 15.6012 10.6089 15.5161C10.451 15.4311 10.3167 15.3081 10.2181 15.1583L8.03516 11.8401Z",
    stroke: "#FF7017",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOpposed;